export const AmbientScribeEmbed = () => {
    return (
        <iframe
            style={{
                width: "100%",
                height: "100%",
                border: "none",
            }}
            src="https://app.tandemhealth.ai/"
            title="Ambient Scribe"
            allow="microphone"
        />
    );
};
